import * as React from 'react';
import { useState } from 'react';
import { RateFinderPriceDialogComponent } from '@digitalopsdev/serviceops-reservations-components';
import type { DayRateSnapshot } from './types';

interface DayRatePriceCellProps {
    dayRate: DayRateSnapshot;
    formatCurrency: (amount: number) => string;
    title?: string;
    itemType?: 'room' | 'program';
}

export function DayRatePriceCell({ dayRate, formatCurrency, title, itemType }: DayRatePriceCellProps) {
    const [showBreakdown, setShowBreakdown] = useState(false);

    const breakdown = dayRate.priceBreakdown;
    const baseAmount = (breakdown?.AmountBeforeDiscount.Gross ?? dayRate.grossAmount) + dayRate.minorAdjustment;
    const payableAmount = (breakdown?.AmountAfterDiscount.Gross ?? dayRate.grossAmount) + dayRate.minorAdjustment;
    const discounted = baseAmount > payableAmount + 0.01;

    if (!discounted) {
        return <span>{formatCurrency(payableAmount)}</span>;
    }

    return (
        <>
            <span
                className="cursor-pointer inline-flex flex-col leading-tight"
                onClick={e => { e.stopPropagation(); setShowBreakdown(true); }}
                title="Click for discount breakdown"
            >
                <span className="text-gray-400 line-through">{formatCurrency(baseAmount)}</span>
                <span className="text-green-600">{formatCurrency(payableAmount)}</span>
            </span>
            <RateFinderPriceDialogComponent
                priceBreakdown={breakdown}
                visible={showBreakdown}
                closed={() => setShowBreakdown(false)}
                title={title ?? 'Price'}
                dateRange={dayRate.date}
                itemType={itemType ?? 'room'}
            />
        </>
    );
}
